import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getUserGroupsByName = payload => api.get('/platform/user-groups/name', payload)

const getUserGroups = payload => api.get('/platform/user-groups', payload)

const getUserGroup = payload =>
  api.get(`/platform/user-groups/${payload.groupId}`, { params: payload.params })

const createUserGroup = payload => api.post('/platform/user-groups', payload)

const deleteUserGroup = payload =>
  api.delete(`/platform/user-groups/${payload.groupId}`, { params: payload.params })

const uploadFile = payload =>
  api.post('/platform/user-groups/upload-file-tmp', payload.data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
    params: payload.params,
  })

const checkFile = payload => api.post('/platform/user-groups/check-file', payload)

const getUploadSucDetail = payload => api.get('/platform/user-groups/upload-suc-detail', payload)

const getUploadErrDetail = payload => api.get('/platform/user-groups/upload-error-detail', payload)

const uploadFileFinal = payload =>
  api.post('/platform/user-groups/upload-file-final', {}, { params: payload.params })

const checkUploadStatus = payload =>
  api.get('/platform/user-groups/upload-status', { params: payload.params })

const userGroupDownload = payload =>
  api.get(`/platform/user-groups/download/${payload.groupId}`, { params: payload.params })

const getAddableUsers = payload =>
  api.get(`/platform/user-groups/users/user-addable/${payload.groupId}`, { params: payload.params })

const addUsersToUserGroup = payload => api.post('/platform/user-groups/users', payload)

export default {
  getUserGroupsByName,
  getUserGroups,
  getUserGroup,
  createUserGroup,
  deleteUserGroup,
  uploadFile,
  uploadFileFinal,
  checkUploadStatus,
  checkFile,
  getUploadSucDetail,
  getUploadErrDetail,
  userGroupDownload,
  getAddableUsers,
  addUsersToUserGroup,
}
